/**
 * Frido PDP — "View real images".
 *
 * Mounts the pill into the gallery, opens the photo grid, and drives the
 * lightbox (hero + filmstrip). The gallery is a Spectrum snippet the SDK
 * re-renders from its own data, so anything placed inside it can be wiped at
 * any time — the pill is therefore re-mounted whenever it goes missing.
 */
(function () {
  if (window.__fridoRliInit) return;
  window.__fridoRliInit = true;

  var OPEN = 'frido-rli__dialog--open';

  function openDialog(d) {
    if (!d || d.open) return;
    d.showModal();
    document.body.style.overflow = 'hidden';
    void d.offsetHeight;
    d.classList.add(OPEN);
  }

  function closeDialog(d, keepScrollLock) {
    if (!d || !d.open) return;
    d.classList.remove(OPEN);
    var wrap = d.querySelector('.frido-rli__wrap, .frido-rli__zoom-wrap');
    var done = false;
    function finalize() {
      if (done) return;
      done = true;
      if (d.open) d.close();
      if (!keepScrollLock) document.body.style.overflow = '';
    }
    if (wrap) {
      wrap.addEventListener('transitionend', function h(e) {
        if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
        wrap.removeEventListener('transitionend', h);
        finalize();
      });
    }
    setTimeout(finalize, 550);
  }

  function setup(root) {
    if (root.__rliReady) return;
    root.__rliReady = true;

    var raw = root.querySelector('[data-rli-data]');
    var items = [];
    try { items = JSON.parse(raw.textContent); } catch (e) { items = []; }
    if (!items.length) return;

    var pill = root.querySelector('[data-rli-open]');
    var grid = root.querySelector('[data-rli-grid]');
    var zoom = root.querySelector('[data-rli-zoomdlg]');
    var zoomImg = root.querySelector('[data-rli-zoom-img]');
    var strip = root.querySelector('[data-rli-strip]');
    var stripItems = strip ? strip.querySelectorAll('[data-rli-strip-item]') : [];
    var index = 0;

    /* The gallery lays out as a positioning context for the pill. */
    function mountPill() {
      if (!pill) return;
      var sel = root.getAttribute('data-rli-anchor') || '.sai-emblag01';
      var host = document.querySelector(sel);
      if (!host) return;
      if (pill.parentElement === host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(pill);
    }

    function show(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      index = i;
      var it = items[i];
      if (zoomImg) {
        zoomImg.src = it.src;
        zoomImg.srcset = it.src800 + ' 800w, ' + it.src + ' 1400w';
        zoomImg.sizes = '(min-width: 750px) 620px, 92vw';
        zoomImg.alt = it.alt || '';
      }
      for (var n = 0; n < stripItems.length; n++) {
        stripItems[n].classList.toggle('is-sel', n === i);
      }
      var sel = stripItems[i];
      if (sel && sel.scrollIntoView) sel.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    /* The pill is moved into the gallery, so it no longer bubbles to `root` —
       bind it directly rather than relying on delegation. */
    if (pill) pill.addEventListener('click', function () { openDialog(grid); });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      if (t.closest('[data-rli-open]')) { openDialog(grid); return; }
      if (t.closest('[data-rli-close]')) { closeDialog(grid); return; }

      var cell = t.closest('[data-rli-zoom]');
      if (cell) {
        show(parseInt(cell.getAttribute('data-rli-zoom'), 10) || 0);
        openDialog(zoom);
        return;
      }
      var item = t.closest('[data-rli-strip-item]');
      if (item) { show(parseInt(item.getAttribute('data-rli-strip-item'), 10) || 0); return; }
      if (t.closest('[data-rli-prev]')) { show(index - 1); return; }
      if (t.closest('[data-rli-next]')) { show(index + 1); return; }
      /* The grid stays open underneath, so keep the scroll lock. */
      if (t.closest('[data-rli-zoom-close]')) { closeDialog(zoom, grid && grid.open); return; }
    });

    /* Click-outside closes, matching the other PDP dialogs. */
    [[grid, '.frido-rli__wrap'], [zoom, '.frido-rli__zoom-wrap']].forEach(function (pair) {
      var d = pair[0];
      if (!d) return;
      d.addEventListener('click', function (e) {
        if (e.target !== d) return;
        var inner = d.querySelector(pair[1]);
        if (inner && !inner.contains(e.target)) closeDialog(d, d === zoom && grid && grid.open);
      });
      d.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeDialog(d, d === zoom && grid && grid.open);
      });
    });

    if (zoom) {
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      });
    }

    mountPill();
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; mountPill(); });
    }
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-frido-rli]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
